




























import { defineComponent, ref } from '@vue/composition-api'

export default defineComponent({
  setup() {
    const tab = ref()
    const outputs = ref<string[]>([])
    return {
      tab,
      outputs,
    }
  },
})
